import { DocumentoSpesaDTO } from "./documento-spesaDTO";
import { TipoBeneficiarioEnum } from "../enum/tipo-beneficiario-enum";

export class AnagraficaBeneficiarioDTO {
  denominazione: string;
  tipoBeneficiario: TipoBeneficiarioEnum;
  codiceFiscale: string;
  partitaIva: string;
  indirizzo: string;
  classeContabile: string;
  codiceFornitore: string;
  iban?: string;
  index: number;
  cap: string;
  comune: string;
  provincia: string;
  documentiSpesa: DocumentoSpesaDTO[];
  ritenuta: number;
  protocolliDomanda: string;
  codiceCor: string;
  noteAggiuntive: string;

}
